import React, { useEffect, useState } from "react";

import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import ContentLoader from "react-content-loader";

export default function TasksFinishedPieChart(props) {
	const [chartData, setChartData] = useState();

	const CustomTooltip = ({ active, payload, label }) => {
		var taskCount = 0;
		props.data.topics.map(entry => {
			taskCount += entry.tasks.length;
		});

        if (active && payload && payload.length) {
            return (
                <div className="rechart-custom-tooltip">
                    <b>{payload[0].name}</b>
                    <p className="m-0">{payload[0].value} von {taskCount} entspricht<br/>einem Anteil von {((payload[0].value / taskCount) * 100).toFixed(0)}%</p>
                </div>
            );
        }
      
        return null;
    };

	let renderLabel = function(entry) {
        return `${entry.name}: ${entry.value}`;
    }

	const updateChart = () => {
		let finishedTasks = 0;
		let unfinishedTasks = 0;

		props.data.topics.map((topic, topicIndex) => {
			topic.tasks.map((task, taskIndex) => {
				if (
					props.data.resolutions
						.filter((x) => x.finished)
						.some((x) => x.taskId === task.id)
				) {
					finishedTasks++;
				} else {
					unfinishedTasks++;
				}
			});
		});

		setChartData([
			{
				name: "Abgeschlossen",
				value: finishedTasks,
				color: "#28a745",
			},
			{
				name: "Ausstehend",
				value: unfinishedTasks,
				color: "#dc3545",
			},
		]);
	}

	useEffect(() => {
		if (props.data !== undefined) {
			updateChart();
		}
	}, [props.data]);

	return (
		<>
			<b className="d-block text-center">Anteil abgeschlossene Aufgaben</b>
			{props.data !== undefined && chartData !== undefined ? (
				<PieChart width={400} height={300} className="d-block mx-auto">
					<Pie
						data={chartData}
						cx="50%"
						cy="50%"
						labelLine={false}
						label={renderLabel}
						outerRadius={70}
						fill="#FF0000"
						dataKey="value">
						{chartData.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={entry.color} strokeWidth={0} />
						))}
					</Pie>

					<Tooltip content={<CustomTooltip />} />
					<Legend />
				</PieChart>
			) : (
				<DummyPieChart />
			)}
		</>
	);
}

const DummyPieChart = (props) => {
	return (
		<ContentLoader
			viewBox="0 0 400 200"
			height={200}
			width={400}
			style={{maxWidth: "100%"}}
			{...props}>
			<rect x="100" y="5" rx="0" ry="0" width="200" height="15" />
			<circle cx="140" cy="110" r="70" />
			<rect x="230" y="50" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="50" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="64" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="64" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="78" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="78" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="92" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="92" rx="0" ry="0" width="30" height="7" />
		</ContentLoader>
	);
};
